<style scoped>
    @import url("../../styles/mv/exibTextmv.scss");
</style>

<template>
    <div class="box_exibTextmv">

        <div class="boxTit">
            <span class="tit">{{ this.t }}</span>
        </div>

        <div class="boxContent" v-if="flagContent">
            
            <div class="boxValue">
                <v-icon size="72" class="mr-2 elValue">{{ this.iconEl }}</v-icon>
                <div class="elValue">{{ valor }} {{ this.unid }}</div>
            </div>

            <div class="boxDate">
                <div class="tDate">Última atualização</div>
                <div class="elDate">{{ date }}</div>
            </div>
        </div>

        <div class="semDados" v-if="!flagContent">
            <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
            <div>AINDA NÃO HÁ DADOS</div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {

    props:['t','iconEl','r','payload','name_key','unid'],

    data() {
        return {
            //
            flagContent:true, // init false (pré axios)

            valor:null,
            date:null,
        }
    },

    methods:{
        //
    },

    created() {
        //console.log('t: ',this.t)
        
        if (this.r != "") {

            let self = this

            //let params = {'cliente':'cliente2'} // -- teste 04/05/2025
            let params = this.payload // -- props

            const url = self.$store.state.pathAxiosBASE + this.r // -- soma string
            //console.log('url: ',url)

            axios.post(url, params).then(function (res) {

                //console.log(res.data.result)

                //console.log('self.payload.name_key: ',self.name_key)
                self.valor = res.data.result.readings[self.name_key]
                //console.log('valor: ',self.valor)
                self.date = res.data.result.date

                //this.payload.name_key // -- recortar essa name_key do el recebido via req.
            })
        }

    }
}
</script>